import moment from "moment";

export function convertUnixToJs(unixTimestamp) {
  return moment.unix(unixTimestamp).format("h:mm:ss a");
}
export function convertUnixToJsWithISODate(unixTimestamp) {
  return moment.unix(unixTimestamp).format("YYYY-MM-DD");
}
export function convertUnixToJsWithDate(unixTimestamp) {
  return moment.unix(unixTimestamp).format("dddd, MMMM Do YYYY, h:mm:ss a");
}
export function convertUnixToJsWithDateNoTime(unixTimestamp) {
  return moment.unix(unixTimestamp).format("MMMM Do YYYY, h:mm:ss a");
}
// same as moment().unix()
export function convertJsToUnixSeconds(date){
  return Math.floor(date.getTime() / 1000);
}
export function areDatesOnSameDay(firstDate, secondDate) {
  return firstDate.getFullYear() === secondDate.getFullYear() &&
  firstDate.getMonth() === secondDate.getMonth() &&
  firstDate.getDate() === secondDate.getDate();
}
export function getStartOfDay(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
};
export function getEndOfDay(date) {
  const d = new Date(date);
  d.setHours(23, 59, 59, 999);
  return d;
}

export function addTimeToDate(date, duration) {
  const newDate = moment(date);
  newDate.add(duration.toString(), "m").toDate();
  return newDate.format("YYYY MMMM DD HH:mm");
}

export function getPastTimeIntervals(hours) {
  const now = moment();
  const startTime = now.clone().subtract(hours, "hours");
  const roundedStartTime = startTime
    .clone()
    .startOf("minute")
    .add(Math.floor(startTime.seconds() / 30) * 30, "seconds");

  const intervals = [];

  while (roundedStartTime <= now) {
    intervals.push({ batch: roundedStartTime.unix() });
    roundedStartTime.add(30, "seconds");
  }

  return intervals;
}

export function processTimestamps(data, key) {
  let timeIntervals = getPastTimeIntervals(6);
  const roundedData = data.map((item) => {
    const roundedTimestamp = Math.floor(item.batch / 30) * 30;
    return { ...item, batch: roundedTimestamp };
  });
  roundedData.forEach((indivData) => {
    const pos = timeIntervals.map((e) => e.batch).indexOf(indivData.batch);
    if (pos !== -1) {
      const objToAdd = {};
      objToAdd.batch = timeIntervals[pos].batch;
      objToAdd[key] = indivData[key];
      timeIntervals[pos] = objToAdd;
    }
  });
  return timeIntervals;
}
